import { Component, Input } from '@angular/core';
import { ViewMode } from '../../../../models';

@Component({
  selector: 'hooxpay-example',
  templateUrl: './hooxpay-example.component.html',
  styleUrls: ['./hooxpay-example.component.scss'],
  standalone: false,
})
export class HooxPayExampleComponent {
  @Input() template;
  @Input() mode: ViewMode = null;

  constructor() {}
}
